import RequestHandler from 'octa-front-sdk/dist/RequestHandler';
import { CardInfo } from '../types/CardInfo';
import { OrderPaymentCardRequest } from '../types/OrderPaymentCardRequest';

const tokenizeCard = (cardInfo: CardInfo): Promise<OrderPaymentCardRequest> => {
  const marketplace_id = process.env.REACT_APP_MARKETPLACE_ID;
  const zpk = process.env.REACT_APP_ZPK || '';
  const { holderName, cardNumber, expirationDate, cvv } = cardInfo;
  const [expiration_month, expiration_year] = expirationDate.split('/');

  const data = {
    holder_name: holderName,
    card_number: cardNumber,
    expiration_month,
    expiration_year,
    secutiry_code: cvv,
  };

  delete RequestHandler.defaults.headers.common['X-Org-Id'];

  return new Promise((resolve, reject): void => {
    RequestHandler.request({
      auth: { username: zpk, password: '' },
      method: 'POST',
      baseURL: 'https://api.zoop.ws',
      url: `v1/marketplaces/${marketplace_id}/cards/tokens`,
      data,
    })
      .then((response): void => {
        const { id: externalToken, card } = response.data;
        const {
          card_brand: brand,
          first4_digits: truncatedNumber,
          expiration_month,
          expiration_year,
        } = card;
        const userPayment: OrderPaymentCardRequest = {
          externalToken,
          brand,
          truncatedNumber,
          validUntil: `20${expiration_year}-${expiration_month}`,
        };

        resolve(userPayment);
      })
      .catch((e): void => reject(e));
  });
};

export default {
  tokenizeCard,
};
